import { placementsToOutbrainWidgets } from './ad_ops/outbrainPlacementWidgets'
import { placementConfigs } from './ad_ops/adPlacementMappings'

export default defineAppConfig({
  nuxtIcon: {},
  openfeature: {
    multiProvider: true,
    localProvider: false,
    queryProvider: true,
  },
  directAdsHostedConfigUrl: '',
  redesignedNtpPaths: [''],
  googleTagManagerId: [''],
  urls: {
    home: '/',
    article: '/article',
    video: '/video',
  },
  assertiveYield: {
    apiUrl: 'https://suite.assertiveyield.com/api/v2',
    entityId: '',
  },
  outbrain: {
    installationKey: '',
    mapPlacementToWidget: placementsToOutbrainWidgets,
  },
  adops: {
    placements: placementConfigs,
  },
  taboola: {
    publisherName: '',
  },
})
